"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.setUpNativeImageMusl = void 0;
const core = __importStar(require("@actions/core"));
const tc = __importStar(require("@actions/tool-cache"));
const constants_1 = require("./constants");
const utils_1 = require("./utils");
const path_1 = require("path");
const MUSL_NAME = 'x86_64-linux-musl-native';
const MUSL_VERSION = '10.2.1';
function setUpNativeImageMusl() {
    return __awaiter(this, void 0, void 0, function* () {
        if (!constants_1.IS_LINUX) {
            core.warning('musl is only supported on Linux');
            return;
        }
        let toolPath = tc.find(MUSL_NAME, MUSL_VERSION);
        if (toolPath) {
            core.info(`Found ${MUSL_NAME} ${MUSL_VERSION} in tool-cache @ ${toolPath}`);
        }
        else {
            core.startGroup(`Setting up musl for GraalVM Native Image...`);
            const muslDownloadPath = yield tc.downloadTool(`http://more.musl.cc/10/x86_64-linux-musl/${MUSL_NAME}.tgz`);
            const muslExtractPath = yield tc.extractTar(muslDownloadPath);
            const muslPath = (0, path_1.join)(muslExtractPath, MUSL_NAME);
            const zlibVersion = '1.2.11';
            const zlibDownloadPath = yield tc.downloadTool(`https://zlib.net/fossils/zlib-${zlibVersion}.tar.gz`);
            const zlibExtractPath = yield tc.extractTar(zlibDownloadPath);
            const zlibPath = (0, path_1.join)(zlibExtractPath, `zlib-${zlibVersion}`);
            const zlibBuildOptions = {
                cwd: zlibPath,
                env: Object.assign(Object.assign({}, process.env), { CC: (0, path_1.join)(muslPath, 'bin', 'gcc') })
            };
            yield (0, utils_1.exec)('./configure', [`--prefix=${muslPath}`, '--static'], zlibBuildOptions);
            yield (0, utils_1.exec)('make', [], zlibBuildOptions);
            yield (0, utils_1.exec)('make', ['install'], { cwd: zlibPath });
            core.info(`Adding ${MUSL_NAME} ${MUSL_VERSION} to tool-cache ...`);
            toolPath = yield tc.cacheDir(muslPath, MUSL_NAME, MUSL_VERSION);
            core.endGroup();
        }
        core.addPath((0, path_1.join)(toolPath, 'bin'));
    });
}
exports.setUpNativeImageMusl = setUpNativeImageMusl;
